import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

export default
@observer class UserManualPage extends Component {

  openUserManual() {
    window.open(uiMsg('UM_URL',"http://www.deconx.com"),"_blank");
  }

  render() {
    return (
      <div style={pageStyle}>
        <h2 style={headerStyle}>{uiMsg('UM_HEADING',"User Manual")}</h2>
        <a href={uiMsg('UM_DX1_QUICK_START_URL')} target={"_blank"}>
            {uiMsg('UM_DX1_QUICK_START',"Decon-X DX1 Quick start guide")}
        </a>
        <br></br>
        <a href={uiMsg('UM_DX1_USER_GUIDE_URL')} target={"_blank"} >
            {uiMsg('UM_DX1_USER_GUIDE',"Decon-X DX1 User Guide")}
        </a>
        <br></br>
        <a href={uiMsg('UM_CP_USER_GUIDE_URL')} target={"_blank"} >
            {uiMsg('UM_CP_USER_GUIDE',"Decon-X Customer Portal User Guide")}
        </a>
        <br></br>
        <a href={uiMsg('UM_FAQ_URL')} target={"_blank"} >
            {uiMsg('UM_FAQ',"FAQ")}
        </a>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/UserManualPage.jsx
 **/